import { SearchOutlined } from "@ant-design/icons";
import { Dropdown, Input, Menu, Modal } from "antd";
import { MenuClickEventHandler } from "rc-menu/lib/interface";
import React, { FC, useState } from "react";
import { AiOutlinePlus } from "react-icons/ai";
import { useIntl } from "react-intl";
import ExportSVG from "../../assets/catalog/ExportSVG";
import FilterSVG from "../../assets/catalog/FilterSVG";
import ExportModal from "../clients/ExportModal";
import PopAddNewClient from "../clients/PopAddNewClient";
import PopBulkUpload from "../clients/PopBulkUpload";

interface HeadTableProps {
  data: any;
  deleteModal: any;
  setDeleteModal: React.Dispatch<React.SetStateAction<boolean>>;
  placeHolderSerch: string;
  button?: any;
  hideSearch?: any;
  hideFilter?: any;
  optionalDiv?: React.ReactNode;
  search?: any;
  setSearch?: any;
  sort?: "asc" | "desc";
  setSort?: React.Dispatch<React.SetStateAction<"asc" | "desc">>;
}

const HeadTable: FC<HeadTableProps> = ({
  data,
  deleteModal,
  setDeleteModal,
  placeHolderSerch,
  optionalDiv,
  hideSearch,
  hideFilter,
  button,
  search,
  setSearch,
  sort,
  setSort,
}) => {
  const [clientsFilter, setClientsFilter] = useState(null);
  const [searchClient, setSearchClient] = useState("");
  const [addingClientModal, setAddingClientModal] = useState(false);
  const [clientBulkModal, setClientBulkModal] = useState(false);
  const [exportModal, setExportModal] = useState(false);

  const showModal = () => {
    setAddingClientModal(true);
  };
  const handleCancel = () => {
    setAddingClientModal(false);
  };
  const showBulkModal = () => {
    setClientBulkModal(true);
  };
  const handleBulkCancel = () => {
    setClientBulkModal(false);
  };
  const showExportModal = () => {
    setExportModal(true);
  };
  const handleExportCancel = () => {
    setExportModal(false);
  };
  const showDeleteModal = () => {
    setDeleteModal(true);
  };
  const handleDeleteCancel = () => {
    setDeleteModal(false);
  };

  const items = [
    {
      label: (
        <div
          className="flex items-center gap-1 px-2 py-1 text-sm"
          onClick={showModal}
        >
          <AiOutlinePlus className="flex items-center text-sm" />
          <span>عميل واحد</span>
        </div>
      ),
      key: "0",
    },
    {
      type: "divider",
    },
    {
      label: (
        <div
          className="flex items-center gap-1 px-2 py-1 text-sm"
          onClick={showBulkModal}
        >
          <AiOutlinePlus className="flex items-center text-sm" />
          <span>تحميل مجمع للعملاء</span>
        </div>
      ),
      key: "1",
    },
  ];
  const intl = useIntl();

  const filtersItems = [
    {
      label: (
        <div
          onClick={() => {
            // setClientsFilter("s");
            if (setSort) {
              setSort("desc");
            }
          }}
          className={
            sort === "desc"
              ? "flex text-sm items-center gap-1 px-2 py-1 font-bold w-full"
              : "flex text-sm items-center gap-1 px-2 py-1 "
          }
        >
          {/* Your SVG or icon here */}

          <span>{intl.formatMessage({ id: "newly_added_label" })}</span>
        </div>
      ),
      key: "0",
    },
    {
      type: "divider",
    },
    {
      label: (
        <div
          onClick={() => {
            // setClientsFilter("appointments");
            if (setSort) {
              setSort("asc");
            }
          }}
          className={
            sort === "asc"
              ? "flex text-sm items-center gap-1 px-2 py-1 font-bold w-full"
              : "flex text-sm items-center gap-1 px-2 py-1 "
          }
        >
          {/* Your SVG or icon here */}
          <span>{intl.formatMessage({ id: "most_booked_label" })}</span>
        </div>
      ),
      key: "1",
    },
  ];

  const renderMenu = (menuItems: any[]) => {
    return (
      <Menu>
        {menuItems.map(
          (item: {
            type: string;
            key: React.Key | null | undefined;
            onClick: MenuClickEventHandler | undefined;
            label:
              | string
              | number
              | boolean
              | React.ReactElement<
                  any,
                  string | React.JSXElementConstructor<any>
                >
              | Iterable<React.ReactNode>
              | React.ReactPortal
              | null
              | undefined;
          }) => {
            if (item.type === "divider") {
              return <Menu.Divider key={item.key} />;
            } else {
              return (
                <Menu.Item key={item.key} onClick={item.onClick}>
                  {item.label}
                </Menu.Item>
              );
            }
          }
        )}
      </Menu>
    );
  };
  return (
    <>
      <Modal
        width="80%"
        open={addingClientModal}
        onCancel={handleCancel}
        footer={null}
        destroyOnClose
      >
        <PopAddNewClient close={handleCancel} />
      </Modal>
      <Modal
        width="80%"
        open={clientBulkModal}
        onCancel={handleBulkCancel}
        destroyOnClose
        footer={null}
      >
        <PopBulkUpload close={handleExportCancel} />
      </Modal>
      <Modal
        centered
        open={exportModal}
        onCancel={handleExportCancel}
        footer={null}
      >
        <ExportModal close={handleBulkCancel} data={data} />
      </Modal>
      <div className="flex flex-col items-center justify-between gap-2 md:flex-row mb-7">
        <div className="flex items-center w-full gap-4">
          <div
            onClick={showExportModal}
            className="border-[0.8px] border-solid border-[#9999A7] w-fit px-3 py-2 flex items-center rounded-lg cursor-pointer bg-white"
          >
            <ExportSVG />
          </div>
          {!hideFilter && (
            <Dropdown overlay={renderMenu(filtersItems)} trigger={["click"]}>
              <div className="border-[0.8px] border-solid border-[#9999A7] w-fit px-3 py-2 flex items-center rounded-lg cursor-pointer bg-white">
                <FilterSVG />
              </div>
            </Dropdown>
          )}

          {optionalDiv}
        </div>
        <div className="flex flex-col items-center gap-5 md:flex-row">
          <div className="flex items-center w-full gap-5">
            {!hideSearch && (
              <Input
                size="small"
                placeholder={placeHolderSerch}
                className="min-w-[200px] lg:min-w-[500px] rounded-lg h-full p-2"
                value={search}
                onChange={(e) => {
                  if (!setSearch) return;
                  setSearch(e.target.value);
                }}
                suffix={
                  <SearchOutlined
                    style={{
                      color: "#9999A7",
                      position: "absolute",
                      right: 8,
                      top: 12,
                    }}
                  />
                }
                style={{ paddingRight: 30 }}
              />
            )}
          </div>
          <div className="">{button}</div>
        </div>
      </div>
    </>
  );
};

export default HeadTable;
